"use client";

import { createContext, useContext, useState, ReactNode } from "react";
import { Organization } from "@/models/Organization";

interface OrganizationContextType {
    selectedOrganization: Organization | null;
    setSelectedOrganization: (org: Organization | null) => void;
}

const OrganizationContext = createContext<OrganizationContextType | undefined>(
    undefined
);

export function OrganizationProvider({ children }: { children: ReactNode }) {
    const [selectedOrganization, setSelectedOrganization] =
        useState<Organization | null>(null);

    return (
        <OrganizationContext.Provider
            value={{ selectedOrganization, setSelectedOrganization }}
        >
            {children}
        </OrganizationContext.Provider>
    );
}

export function useOrganization() {
    const context = useContext(OrganizationContext);
    if (context === undefined) {
        throw new Error(
            "useOrganization must be used within an OrganizationProvider"
        );
    }
    return context;
}
